import { useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

import type { SuggestedPetition, VictoriousPetition } from '../../api';
import type { SuggestedPetitionClickLocation } from '../../types';

type Result = ModelHookResult<
	undefined,
	{
		trackClick: (
			location: SuggestedPetitionClickLocation,
			petition: SuggestedPetition | VictoriousPetition,
			gridPosition: number,
		) => void;
	}
>;

export function useSuggestedPetitionsTracking({
	petitionStatus,
	parentPetitionId,
}: {
	petitionStatus: 'open' | 'victorious';
	parentPetitionId?: string;
}): Result {
	const track = useTracking();

	return {
		actions: useMemo(
			() => ({
				trackClick: (location, petition, gridPosition) => {
					const trackingProperties: TrackingProperties = {
						card_petition_id: petition.node.id,
						page_petition_id: parentPetitionId,
						grid_position: gridPosition,
						petition_status: petitionStatus,
						algorithm: petition.algorithm,
						// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
						strategy: petition.trackingData?.strategy,
					};
					switch (location) {
						case 'title':
							void track('petition_card_click', {
								...trackingProperties,
								click_location: 'title',
							});
							break;
						case 'ellipsis':
							void track('petition_card_click', {
								...trackingProperties,
								click_location: 'read_more',
							});
							break;
						case 'sign':
							void track('petition_card_sign_click', trackingProperties);
							break;
						default:
					}
				},
			}),
			[track, parentPetitionId, petitionStatus],
		),
	};
}
